export const basicEditorXSSOptions = {
    whiteList: {
        b: ['style'],
        i: ['style'],
        u: ['style'],
        a: ['href', 'title', 'target', 'rel'],
        p: ['class', 'style'],
        strong: ['style'],
        em: ['style'],
        br: [],
        s: ['style'],
        span: ['style'],
        ul: [], ol: ['start'], li: [],
        mark: ['style', 'data-color']
    },
    css: {
        whiteList: {
            // Quill stores colors as rgb(), TipTap as hex
            'color': /^(#[0-9a-f]{3,8}|rgba?\([\d\s,.%]+\)|inherit);?$/i,
            'background-color': /^(#[0-9a-f]{3,8}|rgba?\([\d\s,.%]+\)|inherit);?$/i,
            'font-size': /^(\d+(\.\d+)?(px|em|%)|small|medium|large|x-large|xx-large)$/i,
            // TipTap stores alignment as an inline style (Quill used a ql-align-* class)
            'text-align': /^(left|right|center|justify)$/
        }
    }
};

// Unknown tags are removed instead of escaped, and script/style bodies are dropped.
const stripUnknownTags = {
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style']
};

// For admin-written content (TipTap or raw HTML, e.g. banners): basic editor markup plus layout tags and images.
export const rawHtmlXSSOptions = {
    ...basicEditorXSSOptions,
    whiteList: {
        ...basicEditorXSSOptions.whiteList,
        div: ['class', 'style'],
        span: ['class', 'style'],
        hr: [],
        li: ['style'],
        h1: ['style'], h2: ['style'], h3: ['style'], h4: ['style'], h5: ['style'], h6: ['style'],
        img: ['src', 'alt', 'title', 'width', 'height']
    },
    ...stripUnknownTags
};

// Paste into TipTap. Same whitelist as the basic editor, but unknown tags are removed instead of escaped.
// xss does not repair badly nested tags; the editor parses the result via innerHTML, which does.
export const editorPasteXSSOptions = {
    ...basicEditorXSSOptions,
    ...stripUnknownTags
};
